import { useState } from "react";
import styles from "../styles/panic.module.css";
import CloseIcon from "@mui/icons-material/Close";
const PanicAlertTicket = ({
  setShowTicket,
  ticketData,
  isHandled,
  onTicketHandleClick,
  setRemark,
}) => {
  return (
    <div className="alert-ticket">
      <div className={`${!isHandled ? styles.ticketId : styles.ticketIdGreen}`}>
        <p>Ticket Id:{ticketData.PanicCode}</p>

        <CloseIcon onClick={() => setShowTicket(false)} />
      </div>
      <div className={styles.message}>
        <p className={styles.eachMessage}>
          <span>
            Unit Code:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          {ticketData.UnitCode}
        </p>
        <p className={styles.eachMessage}>
          <span>Emp Code:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          {ticketData.EmpCode}
        </p>
        <p className={styles.eachMessage}>
          <span>Emp Name:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          {ticketData.EmpName}
        </p>
        <p className={styles.eachMessage}>
          <span>Panic Type:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          {ticketData.EmpName}
        </p>
        <p className={styles.eachMessage}>
          <span>
            PH
            No:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          {ticketData.Mobile}
        </p>
        <p className={styles.eachMessage}>
          <span>Geo.Loc:&nbsp;&nbsp;</span>
          {ticketData.GeoLoc}
        </p>
        <p className={styles.eachMessage}>
          <span>Time:&nbsp;&nbsp;</span>
          {ticketData.Time}
        </p>
      </div>
      {ticketData.Status === null ? (
        <div className={styles.wrap}>
          <textarea
            className={styles.remarkBox}
            placeholder="Remark..."
            onChange={(e) => setRemark(e.target.value)}
          />
          <div className={styles.btnContainer}>
            <span className={styles.btn} onClick={onTicketHandleClick}>
              Handled
            </span>
            {/* <span className={styles.btn}>Pending</span> */}
          </div>
        </div>
      ) : (
        <div className={styles.remark}>
          <p>
            <span>Remark:</span>
            {ticketData.Remark}
          </p>
        </div>
      )}
    </div>
  );
};
export default PanicAlertTicket;
